module.exports = __webpack_public_path__ + "mainassets/img/faq-3-a.5a277f34.svg";